import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { allTenantRolePermissions } from '../../utils/helper';
import { Autocomplete, TextField } from '@mui/material';
import { upsertTenantRole } from '../../store/actions/partnerAction';
import { SHOW_SNACKBAR } from '../../utils/types';

function AddTenantRole({ setIsShow, selectedRole, onAdd }) {
    let dispatch = useDispatch();
    const { t } = useTranslation();
    const [role, setRole] = useState(selectedRole ?? {});
    const [rolePermissions, setRolePermissions] = useState(allTenantRolePermissions ?? []);

    useEffect(() => {
        if (selectedRole?.isEdit || selectedRole?.isView) {
            rolePermissions?.map((m) => {
                const permission = selectedRole?.rolePermissions?.find((p) => p.name === m.name);
                if (permission) {
                    m.selected = true;
                    m.views?.map((v) => {
                        if (permission.views?.some((view) => view.name === v.name)) {
                            v.selected = true;
                        } else {
                            v.selected = false;
                        }
                    });
                } else {
                    m.selected = false;
                }
            });
            setRolePermissions([...rolePermissions]);
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        const prms = [];
        rolePermissions?.map((m) => {
            if (m.selected) {
                prms.push({ ...m, views: m.views?.filter((v) => v.selected) || [] });
            }
        });
        if (prms?.length > 0) {
            role.displayName = role.name;
            role.rolePermissions = prms;
            dispatch(upsertTenantRole(role, (a) => {
                setIsShow(false);
                onAdd(a);
            }));
        } else {
            dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                    type: "error",
                    message: "Please select at least one permission.",
                    open: true,
                },
            });
            return;
        }
    };

    const onEnterRoleName = (e) => {
        let name = e.target.value?.replace(/ /g, "_");
        const regex = /^[a-zA-Z][a-zA-Z0-9_]*$/;
        if (!name || regex.test(name)) {
            setRole({ ...role, name: name });
        } else if (name) {
            setRole({ ...role, name: name?.replace(e.nativeEvent.data, "") });
        }
    };

    return (<form disabled={selectedRole?.isView} className="height30 flex flex-col justify-between pb-3" onSubmit={handleSubmit}>
        <div className="h-dvh overflow-y-auto p-4">
            <div className="grid grid-cols-12 gap-3 w-full mapPlan">
                <div className="col-span-12">
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label>{t('Role Name')}<span className="text-red-500 text-[14px]">*</span></label>
                    </div>
                    <input
                        type="text"
                        placeholder={t("Enter Role Name")}
                        value={role?.name}
                        onChange={onEnterRoleName}
                        className="border border-gray-300 rounded-md py-1 h-9 w-[100%] text-[13px]"
                        required
                    />
                </div>
                <div className='col-span-12'>
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label>{t('Permissions')}<span className="text-red-500 text-[14px]">*</span></label>
                    </div>
                    <div className='rounded-lg border bg-gray-50'>
                        {rolePermissions?.map((m, i) =>
                            <div className='' key={i}>
                                <div className='pl-2 border pt-1.5'>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" value={m.key} onChange={(e) => {
                                            m.selected = e.target.checked === true;
                                            setRolePermissions([...rolePermissions]);
                                        }} checked={m.selected} className="sr-only peer" />
                                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-theme"></div>
                                        <span className="ms-3 text-sm font-medium text-gray-900">
                                            {m.value}
                                        </span>
                                    </label>
                                </div>
                                {m.views && m.views.length > 0 &&
                                    <div className='pl-12 bg-white'>
                                        <div className="pl-2 pt-1.5 grid grid-cols-2 gap-2 rounded-lg">
                                            {m.views?.map((v, j) => <div key={j}>
                                                <label className="inline-flex items-center cursor-pointer">
                                                    <input type="checkbox" value={v.key} onChange={(e) => {
                                                        v.selected = e.target.checked === true;
                                                        setRolePermissions([...rolePermissions]);
                                                    }} checked={v.selected} className="sr-only peer" />
                                                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-theme"></div>
                                                    <span className="ms-3 text-sm font-medium text-gray-900">
                                                        {v.value}
                                                    </span>
                                                </label>
                                            </div>)}
                                        </div>
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                </div>
                {/* <div className="col-span-12">
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label>{t('Permissions')}<span className="text-red-500 text-[14px]">*</span></label>
                    </div>
                    <Autocomplete disabled={selectedRole?.isView}
                        multiple={true}
                        aria-required={true}
                        value={allTenantRolePermissions?.filter((m) =>
                            role.permissions?.some((s) => s === m.key)
                        )}
                        options={allTenantRolePermissions}
                        isOptionEqualToValue={(option, value) =>
                            option?.key === value?.key
                        }
                        getOptionLabel={(option) => option?.key ?? ""}
                        onChange={(e, value) => {
                            setRole({
                                ...role,
                                permissions: value?.map((c) => c.key) ?? [],
                            });
                        }}
                        sx={{
                            "& .MuiAutocomplete-inputRoot": {
                                padding: "0px",
                            },
                        }}
                        slotProps={{
                            paper: {
                                sx: {
                                    fontSize: "13px", // Change font size of dropdown options
                                }
                            },
                            listbox: {
                                sx: {
                                    fontSize: "13px", // Change font size of listbox items
                                }
                            }
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder="Select Category"
                                className="custom-input"
                                sx={{
                                    "& .MuiInputBase-root": {
                                        padding: "0px",
                                        "&.Mui-focused fieldset": {
                                            borderColor: "none",
                                            border: "0px",
                                        },
                                        fontSize: "13px",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                        backgroundColor: "#FFFFFF",
                                        "& fieldset": {
                                            borderColor: "#ccc",
                                        },
                                        "&:hover fieldset": {
                                            borderColor: "#888",
                                        },
                                        "&.Mui-focused fieldset": {
                                            borderColor: "#1976d2",
                                        },
                                    },
                                }}
                            />
                        )}
                    />
                </div> */}
                <div className="col-span-12">
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label>{t('Description')}</label>
                    </div>
                    <textarea
                        placeholder={t("Enter Description")}
                        rows="2"
                        value={role?.descr}
                        onChange={(e) => setRole({ ...role, descr: e.target.value })}
                        className="border border-gray-300 rounded-md text-[13px] px-3 h-[100px] py-1 w-[100%]"
                    />
                </div>
            </div>
        </div>
        <div className="h-[10vh] px-4 bg-white border-t-[1px] border-grayish relative">
            <div className="flex justify-end gap-2 my-2">
                <button
                    type="submit"
                    className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary"
                >
                    {t('Save')}
                </button>
            </div>
        </div>
    </form>)
}

export default AddTenantRole